import CompanyStatics from "./screens/companyStatics"
import CompanyLeaveSettings from "./screens/companyLeaveSettings"
import Holidays from "./screens/holidays"
import { useState, useEffect } from "react"
const tabList = [
    { name: 'Designations', current: true },
    { name: 'Departments', current: false },
    { name: 'Work Locations', current: false },
    { name: 'Hiring Sources', current: false },
    { name: 'Citizenships', current: false },
    { name: 'Leave Settings', current: false },
    { name: 'Holidays', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Company = () => {
    const [tabs, setTabs] = useState(tabList)
    const [activeTab, setActiveTab] = useState(tabs[0].name)

    useEffect(() => {
        const tab = tabs.find((tab) => tab.current)
        setActiveTab(tab.name)
    }, [tabs])

    return (
        <div>
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                <select
                    id="tabs"
                    name="tabs"
                    onChange={(e) => {
                        const newTabs = tabs.map((tab) => {
                            tab.current = tab.name === e.target.value
                            return tab
                        })
                        setTabs(newTabs)
                    }}
                    className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                    defaultValue={tabs.find((tab) => tab.current).name}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>
            </div>
            <div className="hidden sm:block overflow-x-auto">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                        {tabs.map((tab) => (
                            <span
                                key={tab.name}
                                onClick={() => {
                                    const newTabs = tabs.map((t) => {
                                        t.current = t.name === tab.name
                                        return t
                                    })
                                    setTabs(newTabs)
                                }}
                                className={classNames(
                                    tab.current
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer'
                                )}
                                aria-current={tab.current ? 'page' : undefined}
                            >
                                {tab.name}
                            </span>
                        ))}
                    </nav>
                </div>
            </div>
            {/* Switch case for switching Screens */}
            <div className="py-4">
                {activeTab === 'Designations' && <CompanyStatics title="Designation" _key="designation" />}
                {activeTab === 'Departments' && <CompanyStatics title="Department" _key="department" />}
                {activeTab === 'Work Locations' && <CompanyStatics title="Work Location" _key="work-location" />}
                {activeTab === 'Hiring Sources' && <CompanyStatics title="Hiring Source" _key="source-of-hiring" />}
                {activeTab === 'Citizenships' && <CompanyStatics title="Citizenship" _key="citizenship" />}
                {activeTab === 'Leave Settings' && <CompanyLeaveSettings />}
                {activeTab === 'Holidays' && <Holidays />}
            </div>
        </div>
    )
}
export default Company;